
import { mapState } from 'vuex';

export default {
  i18nComponentKey: 'ReviewsEditLegacy.components.RewardInfo',
  name: 'RewardInfo',
  data() {
    return { displayDialog: false };
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    popupRewardDetail() {
      return this.reviewSettings.popup_reward_detail.replace(
        /%{mileage_type_point_text}/g,
        this.reviewSettings.mileage_type_point_text
      );
    }
  }
};
